import useTranslate from 'hooks/useTranslate';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();

	const handleBackClick = () => {
		navigate(-1);
	};
	return (
		<Container className="mt-5 justify-content-center">
			<Row>
				<Col md={{ span: 6, offset: 3 }} className="text-center">
					<h1>404 - {translate('Common.notFound')}</h1>
					<p>{translate('Common.thePageYouReLookingForDoesnTExist')}</p>
					<Button onClick={() => handleBackClick()} variant="primary">
						{translate('Common.back')}
					</Button>
				</Col>
			</Row>
		</Container>
	);
};

export default NotFound;
